<template>
  <div :to="{ name: 'QRcode顧客頁面' }" class="course-area__col">
    <router-link
      :to="{
        name: 'QRcode顧客頁面',
        params: {
          schedule_time_id: schedule.schedule_time_id,
          course_name: schedule.course.name,
          date_time: date + ' ' + schedule.start_at,
          teacher_name: schedule.user.name,
          font_color: schedule.course.color_code
        }
      }"
      class="course-block"
    >
      <p class="course-block__time">
        {{ schedule.start_at }}-{{ schedule.end_at }}
      </p>
      <p
        class="course-block__name"
        :style="`color:${schedule.course.color_code}`"
      >
        {{ schedule.course.name }}
      </p>
      <!-- <p class="course-block__name junior">中級養生瑜珈</p>
      <p class="course-block__name middle">中級養生瑜珈</p>
      <p class="course-block__name high">中級養生瑜珈</p> -->
      <p class="course-block__teacher">{{ schedule.user.name }}</p>
    </router-link>
  </div>
</template>

<script>
export default {
  props: {
    schedule: {
      type: Object,
      required: true
    },
    date: {
      type: String,
      required: true
    }
  },
  data() {
    return {};
  }
};
</script>
